import { usePdp } from '@context/PdpContext';
import MemberPricingDealsBanner from '../MemberPricingDealsBanner';

const ProductMemberPricing = () => {
  const { hasMemberPriceDifference, price } = usePdp();

  if (!hasMemberPriceDifference || price?.priceType === 'clearance') {
    return null;
  }

  return <MemberPricingDealsBanner />;
};

export default ProductMemberPricing;
